import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chevron-right-icon",
  "aria-label": "Chevron right icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.0303 11.4697C18.3232 11.7626 18.3232 12.2374 18.0303 12.5303L9.03033 21.5303C8.73744 21.8232 8.26256 21.8232 7.96967 21.5303C7.67678 21.2374 7.67678 20.7626 7.96967 20.4697L16.4393 12L7.96967 3.53033C7.67678 3.23744 7.67678 2.76256 7.96967 2.46967C8.26256 2.17678 8.73744 2.17678 9.03033 2.46967L18.0303 11.4697Z"
    }, null, -1)
  ])))
}
export default { render: render }